import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { hasAccess } from '../utils/access';
import { removeAccessToken } from '../utils/cookies';
import Button from './Button';
import './TopBanner.css';

const TopBanner = () => {
    const [isAccess, setIsAccess] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const checkAccess = async () => {
            try {
                const isAccess = await hasAccess();
                setIsAccess(isAccess);
            } catch (error) {
                alert('An error occurred: ' + error);
                setIsAccess(false);
                removeAccessToken();
            }
        };
        checkAccess();
    }, [location]);

    const handleLogout = () => {
        removeAccessToken()
        navigate("/");
    };

    return (
        <div className="top-banner">
            <h1 className="banner-title">Repository Assisstant</h1>
            { isAccess &&
                <Button
                    text={"Logout"}
                    onClick={handleLogout}
                />
            }
        </div>
    );
};

export default TopBanner;

